import React, { Component } from 'react';
import Reflux from 'reflux';
import { Button } from '@arnsbogroup/react-voicearchive'

class UploadButton extends Component {
  render() {
    return (
      <Button
        variant="inline"
        size="sm"
        onClick={this.addNonAvailability} 
        icon={['fa', 'upload']}
      >
        {this.props.type}
      </Button>
    );
  }
}

export { UploadButton };
